export function mobileCatalogItem(path,expanded=false){
 const inside=path==='/catalog'||path.startsWith('/catalog/')||path==='/tops'||path.startsWith('/tops/');
 return inside
  ?{label:'Поиск',icon:'search',action:'catalog-search',ariaLabel:'Поиск по каталогу',active:true,dialog:true,expanded}
  :{label:'Каталог',icon:'leaf',to:'/catalog',active:false};
}
